let ws = null;
let pingInterval = null;

export const connectWebSocket = (token) => {
  if (ws && ws.readyState === WebSocket.OPEN) {
    return ws;
  }

  ws = new WebSocket("wss://uws.ntx.com.vn");
  window.__WS__ = ws;
  ws.onopen = () => {
    console.log("WS CONNECTED");

    ws.send(
      JSON.stringify({
        type: "register",
        channel: token,
      }),
    );
  };

  ws.onmessage = (event) => {
    try {
      console.log("WS MESSAGE", event.data);
      const data = JSON.parse(event.data);

      if (data.type === "FORCE_LOGOUT") {
        clearInterval(pingInterval);

        localStorage.clear();

        window.location.href = "/login";
      }
    } catch (e) {}
  };

  ws.onerror = (error) => {
    console.log("WS ERROR", error);
  };

  ws.onclose = (event) => {
    console.log("WS CLOSE", {
      code: event.code,
      reason: event.reason,
      wasClean: event.wasClean,
    });
    ws = null;
  };

  return ws;
};
